var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76859 0.788965C5.93707 0.407078 6.47893 0.407077 6.64741 0.788965L8.07377 4.02203C8.14349 4.18008 8.29273 4.2885 8.46459 4.30598L11.9802 4.66345C12.3954 4.70567 12.5629 5.22102 12.2518 5.49926L9.6177 7.85487C9.48893 7.97003 9.43193 8.14547 9.46842 8.31432L10.2148 11.7683C10.303 12.1763 9.86461 12.4948 9.50384 12.2849L6.44955 10.5077C6.30023 10.4208 6.11577 10.4208 5.96646 10.5077L2.91217 12.2849C2.5514 12.4948 2.11302 12.1763 2.20119 11.7683L2.94759 8.31432C2.98408 8.14547 2.92707 7.97003 2.7983 7.85487L0.164248 5.49926C-0.146885 5.22102 0.020559 4.70567 0.435819 4.66345L3.95141 4.30598C4.12327 4.2885 4.27251 4.18008 4.34224 4.02203L5.76859 0.788965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIconWhite);
export default __webpack_public_path__ + "static/media/ratingIconWhite.cb65a65e509f912dddda96d2c76e9f9a.svg";
export { ForwardRef as ReactComponent };